import React from 'react';
import TimelineItemWrapper from './TimelineItemWrapper';
import Loader from '../../../components/Loader';
import { isArray, isEmpty } from 'lodash';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Alert from '../../../components/Alert';

let { id: module_id } = module;

const ApprovedEvents = ({
  selection,
  upcomingEvents,
  pastEvents,
  isFetching,
  showPastEvents,
  pastEventsToRender,
  showMorePastEvents,
  questIsFetching,
  showRescheduleTransitionModal,
  navigateToReschedule,
  history,
  linkkipalvelu,
}) => {
  if (isFetching) {
    return <Loader />;
  }

  return (
    <>
      {/* Render current events */}
      {
        <div className="ot-timeline-upcoming-events">
          {isArray(upcomingEvents) &&
            isEmpty(upcomingEvents) &&
            isArray(pastEvents) &&
            isEmpty(pastEvents) && (
              <Alert type="info" message={`${module_id}.no.items`} />
            )}
          {isArray(upcomingEvents) &&
            selection === 'upcoming' &&
            upcomingEvents.map((timelineItem, index) => {
              return (
                <div key={index}>
                  {timelineItem.map((item) => {
                    return (
                      <TimelineItemWrapper
                        qIsfetching={questIsFetching}
                        history={history}
                        past={false}
                        key={item.id}
                        data={item}
                        showRescheduleTransitionModal={
                          showRescheduleTransitionModal
                        }
                        navigateToReschedule={navigateToReschedule}
                        linkkipalvelu={linkkipalvelu}
                      />
                    );
                  })}
                  <hr style={{ paddingBottom: '5px' }} />
                </div>
              );
            })}
        </div>
      }
      {/* Then past events (behind a dropdown) */}
      {isArray(pastEvents) && !isEmpty(pastEvents) && selection === 'past' && (
        <div
          className={classnames({
            'ot-timeline-past-events-container--expanded': showPastEvents,
          })}
        >
          <div className="ot-timeline-past-events__divider" />
          <div className="ot-timeline-past-events">
            {pastEvents
              .slice(0, pastEventsToRender)
              .map((timelineItem, index) => {
                return (
                  <div key={index}>
                    {timelineItem.map((item) => {
                      return (
                        <TimelineItemWrapper
                          history={history}
                          showRescheduleTransitionModal={
                            showRescheduleTransitionModal
                          }
                          past={true}
                          key={item.id}
                          data={item}
                          navigateToReschedule={navigateToReschedule}
                          linkkipalvelu={linkkipalvelu}
                        />
                      );
                    })}
                    <hr />
                  </div>
                );
              })}
            {pastEvents.length > pastEventsToRender && (
              <div className="ot-timeline-past-events-button-wrapper ot-timeline-past-events-container--expanded">
                <button
                  className="ot-timeline-past-events-button-wrapper__button"
                  onClick={showMorePastEvents}
                >
                  <i className="card-expand-toggler__icon icon-angle-down" />
                  <span className="ot-timeline-past-events-button-wrapper__button__text">
                    <FormattedMessage
                      id={`${module_id}.ApprovedEvents.showMore`}
                    />
                  </span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ApprovedEvents;
